import { makeStyles, Theme } from '@material-ui/core';
import { Close, DragIndicator } from '@material-ui/icons';
import React from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { PanoramaDetails } from '../services/UploadManagementServiceTypes';

export interface PanoramaThumbnailProps extends DraggableProvided, DraggableStateSnapshot {
  panorama: PanoramaDetails;
  onPanoramaDeleteClick: (panorama: PanoramaDetails) => void;
  onPanoramaClick: (panorama: PanoramaDetails) => void;
  displayActions: boolean;
  isCurrent: boolean;
}

export const PanoramaThumbnail: React.FunctionComponent<PanoramaThumbnailProps> = (props) => {
  const {
    panorama,
    onPanoramaClick,
    onPanoramaDeleteClick,
    innerRef,
    draggableProps,
    dragHandleProps,
  } = props;
  const styles = useStyle(props);
  return (
    <div
      ref={innerRef}
      {...draggableProps}
      className={styles.thumbnail}
      aria-label='thumbnail'
      aria-selected={props.isCurrent}
      tabIndex={0}
      role='treeitem'
    >
      <div
        className={styles.thumbnailDragIndicator}
        {...dragHandleProps}
        aria-label='drag thumbnail'
      >
        <DragIndicator />
      </div>
      <div
        className={styles.thumbnailDelete}
        onClick={() => onPanoramaDeleteClick(panorama)}
        aria-label='remove thumbnail'
      >
        <Close />
      </div>
      <div onClick={() => onPanoramaClick(panorama)} className={styles.thumbnailImage}>
        <img src={panorama.thumbnailDownloadUrl} alt={panorama.title} />
      </div>
    </div>
  );
};

const useStyle = makeStyles<Theme, PanoramaThumbnailProps>((theme) => ({
  thumbnail: {
    flexShrink: 0,
    position: 'relative',
    margin: '0 8px',
    '&:first-of-type': {
      margin: '0 8px 0 0',
    },
    '&:last-of-type': {
      margin: '0 0 0 8px',
    },
    cursor: 'pointer',
    border: '3px solid transparent',
    borderColor: ({ isCurrent }) => (isCurrent ? `${theme.palette.primary.main}` : 'transparent'),
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    '& svg': {
      fontSize: '42px',
      color: ({ isDragging }) => (isDragging ? theme.palette.primary.main : 'white'),
      transition: 'color 100ms ease-in-out',
    },
    '&:hover svg': {
      color: theme.palette.primary.main,
    },
    maxHeight: '100%',
    width: '354px',
    overflow: 'hidden',
    transition: 'border-color 100ms ease-in-out, color 100ms ease-in-out',
  },
  thumbnailImage: {
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    userSelect: 'none',
    '&>img': {
      width: '100%',
      pointerEvents: 'none',
      objectFit: 'none',
    },
  },
  thumbnailDragIndicator: {
    display: ({ displayActions }) => (displayActions ? 'block' : 'none'),
    position: 'absolute',
  },
  thumbnailDelete: {
    display: ({ displayActions }) => (displayActions ? 'block' : 'none'),
    right: 0,
    position: 'absolute',
  },
}));
